import { ClaimsService } from './../../../core/services/claims.service';
import { AuthService } from './../../../core/services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { startWith } from 'rxjs/operators';
import swal from 'sweetalert2';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-search-claims',
  templateUrl: './search-claims.component.html',
  styleUrls: ['./search-claims.component.scss']
})
export class SearchClaimsComponent implements OnInit {

  searchForm = new FormGroup({
    ClaimId: new FormControl('', Validators.required),
    memberId: new FormControl('', Validators.required),
  });

  memberData: any = new MatTableDataSource();

  displayedColumns: string[] = ['claimId', 'claimStatus', 'admissionDate', 'dischargeDate', 'memberId', 'memberName', 'assign'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  loaderHide: boolean = true;


  searchClaim = false;
  searchMember = false;

  constructor(
    public dialog: MatDialog,
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private claimsService: ClaimsService,
    private dialogRef: MatDialogRef<SearchClaimsComponent>) {

  }
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  close() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

  updateValidity(mode: any) {
    if (mode === 'claimId') {
      this.searchForm.controls['memberId'].setValue('');
      this.searchForm.controls['memberId'].setValidators(null);
      this.searchForm.controls['memberId'].updateValueAndValidity();
      this.searchForm.controls['ClaimId'].setValidators(Validators.required);
      this.searchForm.controls['ClaimId'].updateValueAndValidity();
      this.searchClaim = true;
      this.searchMember = false;
    } else if (mode === 'memberId') {
      this.searchForm.controls['ClaimId'].setValue('');
      this.searchForm.controls['memberId'].setValidators(Validators.required);
      this.searchForm.controls['memberId'].updateValueAndValidity();
      this.searchForm.controls['ClaimId'].setValidators(null);
      this.searchForm.controls['ClaimId'].updateValueAndValidity();
      this.searchClaim = false;
      this.searchMember = true;
    }
  }

  getMemberClaimDetails() {
    this.loaderHide = false;
    let applicableFor = '';

    const { ClaimId, memberId } = this.searchForm.getRawValue();
    var req_params = new Map([
      ['claim_id', ClaimId],
      ['member_id', memberId]
    ]);
    this.claimsService.fetchMemberClaimDetails(req_params).subscribe(
      (data: any) => {
        this.loaderHide = true;
        data.body.sort((a: any, b: any) => (parseInt(a.alternateClaimId) > parseInt(b.alternateClaimId) ? -1 : 1));
        this.memberData = new MatTableDataSource(data.body);
        this.memberData.paginator = this.paginator;
      },
      (error: any) => {
        this.loaderHide = true;
        swal.close();
        swal.fire(error, '', 'error');
        if (error === 'Session logged out. Please login again!') {

          this.authService.logoutService();
        }
      });
  }

  openClaimInitiation(claimId: any) {
    this.dialogRef.close();
    const tempClaimId = claimId.split('/').join('_');
    this.router.navigate(['/home/claim-initiation/'+ tempClaimId], {skipLocationChange: true});
  }

  openClaimDetails(claimId: any, state: any) {
    swal.showLoading();
    const tempClaimId = claimId.split('/').join('_');
    if (state === 'assign') {
      this.claimsService.isClaimAssign(claimId).subscribe(
        (data: any) => {
          if (data.body && data.message != 'Claim assigned to the requesting user.') {
            swal.fire(data.message, '', 'info')
          } else {
            this.claimsService.assignClaim(claimId).subscribe(
              (assignClaim: any) => {
                swal.close();
                this.dialogRef.close();
                swal.fire(assignClaim.message, '', 'info')
                this.router.navigate(['/claims/claimDetails/' + tempClaimId + '/' + state], { queryParams: { claimData: JSON.stringify(assignClaim.body) }, skipLocationChange: true });
              }, error => {
                swal.close();
                swal.fire(error, '', 'error')
              }
            )
          }
        }, error => {
          swal.close();
          swal.fire(error, '', 'error')
        }
      )
    } else {
      this.dialogRef.close();
      this.router.navigate(['/claims/claimDetails/' + tempClaimId + '/' + state], { skipLocationChange: true });
    }
  }
  openRetailClaimDetails(claimId:any, state:string ){
    this.dialogRef.close();
    this.router.navigate(['/claims/retailClaimDetails/' + claimId + '/' + state], { skipLocationChange: true })
    // this.retailService.getRetailClaimDetails(claimId).subscribe(()=>{
    // })
  }

  hasCA(data: any): boolean {
      let claimId = data.id ? data.id :data.claimId;
      let type = claimId.split('/')[1];
      return type === 'CA';
    }
  hasNoTCA(data: any): boolean {
      let claimId = data.id ? data.id :data.claimId
      let type = claimId.split('/')[1];
      return type !== 'CA';
    }

}